/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'notification': {
    width: 24,
    height: 27,
    viewBox: '0 0 24 27',
    data: '<path pid="0" d="M12 26.04c-1.948 0-3.597-1.39-3.982-3.27h-4.64A2.788 2.788 0 01.6 19.97a2.79 2.79 0 012.588-2.792v-5.057c0-3.775 2.353-7.118 5.824-8.379v-.125C9.012 1.953 10.35.6 12 .6c1.653 0 2.988 1.35 2.988 3.017v.125c3.47 1.26 5.824 4.605 5.824 8.379v5.057a2.79 2.79 0 012.588 2.793c0 1.544-1.243 2.798-2.778 2.798h-4.64c-.385 1.88-2.034 3.271-3.982 3.271zm-1.792-3.27A1.975 1.975 0 0012 23.931c.786 0 1.477-.47 1.793-1.163h-3.585zm.113-17.231c-2.956.769-5.039 3.475-5.039 6.582v5.233a1.919 1.919 0 01-1.908 1.926.686.686 0 00-.68.69c0 .383.306.69.684.69h17.245a.688.688 0 00.683-.69c0-.38-.307-.69-.68-.69a1.915 1.915 0 01-1.908-1.926v-5.233c0-3.107-2.082-5.813-5.039-6.582l-.785-.204V3.617A.9.9 0 0012 2.709a.903.903 0 00-.894.908v1.718l-.785.204z" _fill="#FFF" fill-rule="nonzero"/>'
  }
})
